import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <nav className="navbar is-dark">
      <div className="navbar-brand">
        <a className="navbar-item" href="/">
          🧙‍♂️ My D&D Portfolio
        </a>
      </div>
      <div className="navbar-menu">
        <div className="navbar-start">
          <Link className="navbar-item" to="/">Home</Link>
          <Link className="navbar-item" to="/about">About</Link>
          <Link className="navbar-item" to="/portfolio">Portfolio</Link>
          <Link className="navbar-item" to="/blog">Tavern Talk</Link>
          <Link className="navbar-item" to="/contact">Contact</Link>
        </div>
      </div>
    </nav>
  );
}

export default Header;
